export const validateEnvironment = () => {
  const requiredEnvVars = ['REACT_APP_THE_GRAPH_API_KEY'];
  const missing = requiredEnvVars.filter(key => !process.env[key]);
  
  if (missing.length > 0) {
    throw new Error(
      `Missing required environment variables: ${missing.join(', ')}\n` +
      'Please check your .env file in the project root and ensure all variables are set.\n' +
      'The .env file should contain: REACT_APP_THE_GRAPH_API_KEY=your_api_key_here'
    );
  }
};
